import { render, staticRenderFns } from "./ManageServiceCode.vue?vue&type=template&id=33fa3b97"
import script from "./ManageServiceCode.vue?vue&type=script&lang=js"
export * from "./ManageServiceCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports